import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import AGalleryButton from '../../atoms/_atoms.gallery-button';
import MIndicators from '../../molecules/_molecules.indicators';
import MTestimonial from '../../molecules/_molecules.testimonial';

export default class OTestimonial extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			index: 0,
			testimony: get(props, 'items[0].description', ''),
			author: get(props, 'items[0].author', ''),
			testimonies: props.items,
		};

		this.bindHandles();
	}

	componentWillReceiveProps(props) {
		if (props.items && props.items.length && props.items !== this.state.testimonies) {
			this.setState({
				testimonies: props.items,
				testimony: props.items[0].description,
				author: props.items[0].author,
			});
		}
	}

	bindHandles() {
		this.handleNext = this.handleNext.bind(this);
		this.handlePrevious = this.handlePrevious.bind(this);
	}

	handleNext() {
		if (this.state.index < (this.state.testimonies.length - 1)) {
			const index = this.state.index + 1;
			this.setState({ index });
			this.changeTestimonial({ index });
		}
	}
	handlePrevious() {
		if (this.state.index > 0) {
			const index = this.state.index - 1;
			this.setState({ index });
			this.changeTestimonial({ index });
		}
	}

	changeTestimonial({ index }) {
		this.setState(prevState => ({
			testimony: prevState.testimonies[index].description,
			author: prevState.testimonies[index].author,
		}));
	}

	render() {
		return (
			<section className="o-testimonial">
				<AGalleryButton
					type="left"
					onClick={this.handlePrevious}
				/>

				<article className="o-testimonial--content">
					<div />
					<MTestimonial
						text={this.state.testimony}
						name={this.state.author}
					/>
					<MIndicators
						amount={this.state.testimonies.length}
						value={this.state.index}
					/>
				</article>

				<AGalleryButton
					type="right"
					onClick={this.handleNext}
				/>
			</section>
		);
	}
}

OTestimonial.propTypes = {
	items: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/organisme/house_hold/_organisme.testimonial.js